export enum ScheduleRepeatTypeEnum {
  noRepeat = 'noRepeat',
  specificDates = 'specificDates',
  weekDays = 'weekDays'
}
